import React from "react";
import Layout from "@/components/Layout";
import SectionHeader from "@/components/SectionHeader";
import { useI18n } from "@/i18n";

const content = {
  privacy: {
    lt: [
      { h: "1. Bendra informacija", p: "MAD TURBO gerbia savo klientų privatumą. Ši privatumo politika paaiškina, kokius asmens duomenis renkame ir kaip juos naudojame." },
      { h: "2. Renkami duomenys", p: "Renkame vardą, kontaktinius duomenis, automobilio informaciją ir jūsų pateiktus pranešimus – tik tiek, kiek reikalinga paslaugoms teikti." },
      { h: "3. Duomenų naudojimas", p: "Duomenys naudojami konsultacijoms, paslaugų teikimui ir bendravimui su klientais. Duomenų neperduodame trečiosioms šalims be pagrindo." },
      { h: "4. Slapukai", p: "Naudojame būtinus ir analitinius slapukus. Detali informacija – Slapukų politikoje." },
      { h: "5. Jūsų teisės", p: "Turite teisę susipažinti su savo duomenimis, juos ištaisyti ar prašyti ištrinti. Susisiekite dėl klausimų." },
    ],
    en: [
      { h: "1. General", p: "MAD TURBO respects our clients' privacy. This policy describes what personal data we collect and how we use it." },
      { h: "2. Data collected", p: "We collect name, contact details, vehicle information and any messages you submit — only what is required to provide services." },
      { h: "3. Use of data", p: "Data is used for consultations, service delivery and customer communication. We do not share data with third parties without cause." },
      { h: "4. Cookies", p: "We use necessary and analytical cookies. Details in the Cookie Policy." },
      { h: "5. Your rights", p: "You may access, correct or request deletion of your data. Contact us for any questions." },
    ],
  },
  cookies: {
    lt: [
      { h: "1. Kas yra slapukai", p: "Slapukai – tai maži tekstiniai failai, saugomi jūsų įrenginyje. Jie naudojami svetainės funkcionalumui ir statistikai." },
      { h: "2. Naudojami slapukai", p: "Būtini slapukai (kalbos pasirinkimas, autentifikacija), analitiniai slapukai (Google Analytics)." },
      { h: "3. Sutikimas", p: "Naršydami svetainėje sutinkate su slapukų naudojimu. Nustatymus galite keisti naršyklėje." },
    ],
    en: [
      { h: "1. What are cookies", p: "Cookies are small text files stored on your device. They support site functionality and analytics." },
      { h: "2. Cookies we use", p: "Necessary cookies (language preference, authentication), analytics cookies (Google Analytics)." },
      { h: "3. Consent", p: "By browsing the site you agree to cookie usage. You can change settings in your browser." },
    ],
  },
  terms: {
    lt: [
      { h: "1. Paslaugų teikimas", p: "MAD TURBO teikia ECU kalibravimo, diagnostikos ir programavimo paslaugas. Paslaugų sąlygos aptariamos individualiai su kiekvienu klientu." },
      { h: "2. Atsakomybė", p: "Prieš kiekvieną kalibravimą darome originalų ECU backup. Klientas atsakingas už automobilio hardware būklę." },
      { h: "3. Garantija", p: "Gamintojo garantija gali būti paveikta modifikacijų. Rekomenduojame konsultuotis prieš darbą." },
      { h: "4. Apmokėjimas", p: "Apmokėjimo sąlygos aptariamos prieš darbo pradžią. Priimame banko pavedimą ir kortelę." },
    ],
    en: [
      { h: "1. Services", p: "MAD TURBO provides ECU calibration, diagnostics and programming. Service terms are discussed individually with each client." },
      { h: "2. Liability", p: "Before every calibration we take an original ECU backup. The client is responsible for the vehicle hardware state." },
      { h: "3. Warranty", p: "OEM warranty may be affected by modifications. We recommend consulting before any work." },
      { h: "4. Payment", p: "Payment terms are discussed before work begins. We accept bank transfer and card." },
    ],
  },
};

const titles = {
  privacy: { lt: "Privatumo politika", en: "Privacy Policy" },
  cookies: { lt: "Slapukų politika", en: "Cookie Policy" },
  terms: { lt: "Taisyklės ir sąlygos", en: "Terms & Conditions" },
};

export default function Legal({ page }) {
  const { lang } = useI18n();
  const items = content[page][lang];
  return (
    <Layout seoTitle={titles[page][lang]}>
      <section className="section-y">
        <div className="container-mt max-w-3xl">
          <SectionHeader kicker="Legal" title={titles[page][lang]} />
          <div className="space-y-8">
            {items.map((it, i) => (
              <div key={i}>
                <h3 className="h-display text-2xl text-white mb-3">{it.h}</h3>
                <p className="text-zinc-300 leading-relaxed">{it.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
